/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiProfileCvUploadMutationRequest,
  PostApiProfileCvUploadMutationResponse,
} from '../models/PostApiProfileCvUpload.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiProfileCvUploadMutationResponseSchema,
  postApiProfileCvUploadMutationRequestSchema,
} from '../zod/postApiProfileCvUploadSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiProfileCvUploadMutationKey = () =>
  [{ url: '/api/profile/cv/upload' }] as const;

export type PostApiProfileCvUploadMutationKey = ReturnType<
  typeof postApiProfileCvUploadMutationKey
>;

/**
 * {@link /api/profile/cv/upload}
 */
export async function postApiProfileCvUpload(
  data: PostApiProfileCvUploadMutationRequest,
  config: Partial<RequestConfig<PostApiProfileCvUploadMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiProfileCvUploadMutationRequestSchema.parse(data);
  const formData = new FormData();
  if (requestData) {
    Object.keys(requestData).forEach((key) => {
      const value = requestData[key as keyof typeof requestData];
      if (typeof value === 'string' || (value as unknown) instanceof Blob) {
        formData.append(key, value as unknown as string | Blob);
      }
    });
  }
  const res = await request<
    PostApiProfileCvUploadMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiProfileCvUploadMutationRequest
  >({
    method: 'POST',
    url: `/api/profile/cv/upload`,
    data: formData,
    ...requestConfig,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...requestConfig.headers,
    },
  });
  return postApiProfileCvUploadMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/profile/cv/upload}
 */
export function usePostApiProfileCvUpload<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProfileCvUploadMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiProfileCvUploadMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiProfileCvUploadMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiProfileCvUploadMutationKey();

  return useMutation<
    PostApiProfileCvUploadMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiProfileCvUploadMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiProfileCvUpload(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
